/** @format */

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './Media.css';
import Structure from './containers/Structure';

function App() {
  return (
    <div className='App'>
      <Structure />
    </div>
  );
}

export default App;
